import React, { Fragment } from "react";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Routers from "../../routers/Routers";
import ReactWhatsappButton from "react-whatsapp-button";

const Layout = () => {
  return (
    <Fragment>
      <Header />
      <div>
        <Routers />
      </div>
      <div className="App">
      <ReactWhatsappButton
        countryCode="254"
        phoneNumber="750542046"
        message="Hello, just visited your website and I am interested in a package."
        animated
      />
    </div>
      <Footer />
    </Fragment>
  );
};

export default Layout;
